import * as React from 'react';
import * as styles from '../help/help.module.scss';
import HelpDocument from '../../models/helpDocument';
import ShadowDOMContent from '../management/clientHelpDocuments/shadow-dom-content';

interface Props {
  document: HelpDocument;
  activeDoc: number;
  showAltText?: boolean;
}

/**
 * HelpContent
 * @function HelpContent - Component that displays each individual help document
 */
const HelpContent = ({ document, activeDoc, showAltText }: Props) => {
  const docRef = React.useRef(null);

  // If the active document changes, the window will scroll to the appropriate document
  React.useEffect(() => {
    if (activeDoc === document.snippetGroupId) {
      return docRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }, [activeDoc]);
  return (
    <div ref={docRef} className={styles.document}>
      <ShadowDOMContent document={document} showAltText={showAltText} />
    </div>
  );
};

export default HelpContent;
